import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { QqcModule } from '@nibtravel/qqc/feature-shell/qqc';
import { CookiesAlertModule } from '@nibtravel/shared/features/cookies-alert';
import { HeroModule } from '@nibtravel/shared/ui/components/hero';
import { LayoutModule } from '@nibtravel/shared/ui/components/layout';
import { TravelAlertModule } from '@nibtravel/quote/common/features/travel-alert';
import { AppConfigModule } from '@nibtravel/shared/util/app-config';
import { FeatureToggleModule } from '@nibtravel/shared/util/feature-toggle';
import { ContentfulModule } from '@nibtravel/shared/features/contentful';
import { AlertModule } from '@nibtravel/shared/ui/components/alert';

import { HomeComponent } from './home.component';
import { DomModule } from '@nibtravel/shared/util/dom';

@NgModule({
  imports: [
    CommonModule,
    AppConfigModule,
    RouterModule.forChild([
      {
        path: '',
        pathMatch: 'full',
        component: HomeComponent,
      },
    ]),

    FeatureToggleModule.forChild(),
    LayoutModule,
    ReactiveFormsModule,
    QqcModule,
    HeroModule,
    TravelAlertModule,
    AlertModule,
    CookiesAlertModule,
    ContentfulModule,
    DomModule,
  ],
  declarations: [HomeComponent],
  exports: [HomeComponent],
})
export class HomeModule {}
